// src/components/RideBookingModal.js
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const RideBookingModal = ({ onClose, rideId, from, to, finalPrice, stopName, stopPrice }) => {
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSendAndPay = () => {
    if (!message.trim()) {
      alert("Please enter a message first.");
      return;
    }

    setLoading(true);

    // ⭐ Pass FINAL PRICE + STOP INFO
    const url = `/ride-payment?rideId=${rideId}
      &from=${encodeURIComponent(from)}
      &to=${encodeURIComponent(to)}
      &message=${encodeURIComponent(message)}
      &finalPrice=${finalPrice || 0}
      &stopName=${encodeURIComponent(stopName || "")}
      &stopPrice=${stopPrice || 0}
    `.replace(/\s+/g, "");

    navigate(url);
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-30 flex justify-center items-center z-50">
      <div className="bg-white p-6 rounded-xl w-full max-w-md shadow-lg">
        <h3 className="text-lg font-bold mb-4">Why do you want to book this ride?</h3>

        <textarea
          rows={4}
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          className="w-full border rounded p-2 text-sm mb-4"
          placeholder="Write a short message to the driver..."
        />

        <div className="flex justify-end gap-3">
          <button
            onClick={onClose}
            className="px-4 py-2 text-sm border rounded hover:bg-gray-100"
          >
            Cancel
          </button>

          <button
            onClick={handleSendAndPay}
            disabled={loading}
            className="bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700 disabled:opacity-50"
          >
            {loading ? "Redirecting..." : "Send & Pay"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default RideBookingModal;
